import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import NotificationCard from 'components/cards/NotificationCard/NotificationCard'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'

import styles from './widgets.module.sass'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'

export const renderNotifications = (notifications, i18n) => {
	const cardLabels = {
		options: i18n`Options`,
		unread: i18n`Mark as Unread`,
		read: i18n`Mark as Read`,
		reject: i18n`Close`,
		postpone: i18n`Postpone`,
		reply: i18n`Reply`,
		// Removed forward to backoffice, because backoffice is to be removed
		// forward: i18n`Forward to manager`,
	}

	return (notifications || []).map((notification, index) => {
		return (
			<NotificationCard
				className={styles['notification-card']}
				key={index}
				data={{ ...notification, $cardLabels: cardLabels }}
			/>
		)
	})
}

const NotificationsWidget = (props) => {
	const { data } = props
	const { notifications, process } = data
	const { i18n, showDialog } = useGlobal()

	return (
		<ExpandableWidget
			className={styles['aside-widget']}
			titleAppearance='aside-widget'
			arrowPosition='right'
			heading='h5'
			icon='bell'
			title={i18n`Notifications`}
			collapsedLabel={notifications?.length}
			expanded={true}
			borderRadius
			margins={['small', '', '']}
			paddings={['xsmall', 'xsmall', 'xsmall']}
		>
			{notifications?.length ? (
				renderNotifications(notifications, i18n)
			) : (
				<div
					className={styles['no-notifications']}
				>{i18n`There are no notifications for user.`}</div>
			)}

			{process?.id && (
				<Widget
					className={styles['centered']}
					paddings={['small', '', '']}
					justify='center'
				>
					<ActionButton
						secondary
						onClick={() => {
							showDialog(
								'NotificationHistoryDialog',
								i18n`Notification History`,
								{
									processId: process?.id,
								},
								false,
								undefined,
								undefined,
								'center'
							).catch(() => null)
						}}
					>
						<small>
							<strong>{i18n`See all notifications`}</strong>
						</small>
					</ActionButton>
				</Widget>
			)}
		</ExpandableWidget>
	)
}

export default NotificationsWidget
